import { Box, Link, Typography } from '@mui/material';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import ProgressBar from './ProgressBar';
import { ONLINE_CART_TOKENS } from './style';

const LOGO = 'https://media.base44.com/images/public/user_69b781b8d21f98b606ac32a6/4bdd84d3c_PCS_logo-horizontal_rgb__Duo-Air-Force.png';

export default function CardHeader({ currentStep, showProgress = true, onSectionClick, sections = [] }) {
    const totalSteps = sections.reduce((sum, section) => sum + (section.stepCount || 0), 0);

    return (
        <Box
            component="header"
            sx={{
                backgroundColor: ONLINE_CART_TOKENS.surface,
                borderBottom: `1px solid ${ONLINE_CART_TOKENS.borderSoft}`,
                position: 'sticky',
                top: 0,
                zIndex: 50,
            }}
        >
            <CardHeaderLogo />
            {showProgress && currentStep >= 1 && currentStep <= totalSteps && (
                <ProgressBar currentStep={currentStep} onSectionClick={onSectionClick} sections={sections} />
            )}
        </Box>
    );
}

const CardHeaderLogo = () => {
    return (
        <Box
            sx={{
                maxWidth: '896px',
                mx: 'auto',
                minHeight: { xs: 80, sm: 96 },
                px: { xs: 2, sm: 3 },
                fontFamily: ONLINE_CART_TOKENS.fontFamily,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 2,
            }}
        >
            <Box
                component="img"
                src={LOGO}
                alt="Prime Corporate Services"
                sx={{
                    height: { xs: 56, sm: 80 },
                    width: 'auto',
                    display: 'block',
                }}
            />

            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    color: ONLINE_CART_TOKENS.textHeadingSoft,
                    flexShrink: 0,
                }}
            >
                <LocalPhoneOutlinedIcon sx={{ fontSize: 18, color: ONLINE_CART_TOKENS.textHeadingSoft }} />
                <Typography
                    variant="body2"
                    sx={{
                        fontWeight: 600,
                        color: ONLINE_CART_TOKENS.textHeadingSoft,
                        fontSize: '0.875rem',
                        display: { xs: 'none', sm: 'inline' },
                    }}
                >
                    Call us:
                </Typography>
                <Link
                    href="tel:8555774639"
                    underline="none"
                    sx={{
                        fontSize: '0.875rem',
                        fontWeight: 600,
                        color: ONLINE_CART_TOKENS.textHeadingSoft,
                        lineHeight: 1.4,
                        '&:hover': {
                            color: ONLINE_CART_TOKENS.primaryStrong,
                        },
                    }}
                >
                    (855) 577-4639
                </Link>
            </Box>
        </Box>
    );
};
